import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { supabase } from '@/lib/supabase'

export default function AuthCallback() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    async function handleCallback() {
      const token_hash = searchParams.get('token_hash')
      const type = searchParams.get('type')
      const code = searchParams.get('code')
      const next = searchParams.get('next') || '/redirect'

      // OAuth flow (Microsoft, Google, etc.)
      if (code) {
        const { error } = await supabase.auth.exchangeCodeForSession(code)
        if (!error) {
          navigate(next, { replace: true })
          return
        }
      }

      // Magic link flow
      if (token_hash && type) {
        const { error } = await supabase.auth.verifyOtp({
          type: type as 'email' | 'magiclink',
          token_hash,
        })
        if (!error) {
          navigate(next, { replace: true })
          return
        }
      }

      // If we get here, check if session already exists (auto-detected by Supabase client)
      const { data: { session } } = await supabase.auth.getSession()
      if (session) {
        navigate(next, { replace: true })
        return
      }

      setError('Unable to sign in. Please try again.')
    }

    handleCallback()
  }, [navigate, searchParams])

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-destructive text-sm">{error}</div>
      </div>
    )
  }

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-muted-foreground text-sm">Signing in...</div>
    </div>
  )
}
